export default __webpack_public_path__ + "static/media/coding.a05ff9ad.svg";